module.exports = __webpack_public_path__ + "static/img/beian.557ec47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/beian.png
// module id = X4ev
// module chunks = 1